import PropTypes from 'prop-types';
export const readingTimePropTypes = {
  /**
   * Reading time: value(number)
   */
  value: PropTypes.number.isRequired,
  /**
   * Reading time: unit(string) : Default value is 'min'
   */
  unit: PropTypes.string
};